import { useState, forwardRef, useEffect, useContext } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  Slide,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  List,
  ListItem,
  ListItemButton,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { EventContext } from "../../../contexts/EventContext";

import request from "../../../utilities/requests";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const SendPromptDialog = ({ open, close }) => {
  const { pairingEvent } = useContext(EventContext);
  const [prompts, setPrompts] = useState([]);
  const [selected, setSelected] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    getPrompts();
  }, []);

  const getPrompts = async () => {
    const result = await request("prompts");
    if (result.success) {
      setPrompts(result.prompts);
    }
  };

  const handleSend = async (id) => {
    setSelected(id);
    if (!selected) {
      return;
    }
    if (id === selected) {
      const body = { id, eventId: pairingEvent?.event?._id };
      const result = await request(`prompts/show`, "post", body);
      if (!result.success) {
        alert('prompt error')
      }
    }
  };

  const handleClose = () => {
    setSelected(null);
    close();
  }

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Send a prompt
          </Typography>
        </Toolbar>
      </AppBar>

      <DialogContent>
        <List>
          {prompts.map((prompt, p) => {
            return (
              <div key={`${p}-${prompt._id}`}>
                <ListItem key={`listitem-${prompt._id}`}>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography> {prompt?.name}</Typography>
                    <Button
                      variant={
                        selected === prompt._id ? "contained" : "outlined"
                      }
                      size="small"
                      style={{ width: 80 }}
                      onClick={(e) => handleSend(prompt._id)}
                    >
                      {selected === prompt._id ? "confirm" : "send"}
                    </Button>
                  </div>
                </ListItem>
                <Divider />
              </div>
            );
          })}
        </List>
      </DialogContent>
    </Dialog>
  );
};

export default SendPromptDialog;
